module.exports = __webpack_public_path__ + "img/onekey__expedia.e4d284d8.svg";